// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fa","advertDetailHeaderPrice__value":"c-m_fb","advertDetailHeaderPrice__label":"c-m_fc"};